// Single source of truth for role → permissions (mirrors backend ROLE_PERMISSIONS).
// company_admin inherits asset_admin's permissions (manage_assets/manage_surplus).
export const ROLE_PERMISSIONS = {
  app_admin: ["*"],
  admin: ["*"],
  company_admin: ["manage_assets", "manage_surplus", "manage_staff", "manage_projects", "equip_site_office"],
  asset_admin: ["manage_assets", "manage_surplus", "equip_site_office"],
  staff_admin: ["manage_staff", "equip_site_office"],
  staff_obra: ["equip_site_office"],
  staff_oficina: [],
  project_manager: [],
  cost_dept: [],
};

export function hasPermission(user, perm) {
  const perms = ROLE_PERMISSIONS[user?.role] || [];
  return perms.includes("*") || perms.includes(perm);
}
